import {FilterOutlined} from '@ant-design/icons';
import { Popover,Badge } from 'antd';
import PopoverContent from './PopoverContent';
import useAntFilter from './useAntFilter';
import AntButton from '../AntButton/AntButton';
import {useState } from 'react';



const AntFilter = ({fields,getData}) => {
  
  const[filterStatus,setFilterStatus]=useState(false)
  const getFilterStatus =(filterStatus)=>{setFilterStatus(filterStatus)}


const  { 
    filterOpen,
    handleOpenChange,
 } = useAntFilter()
    return(
    <Popover
    content={<PopoverContent fields={fields} getData={getData} getFilterStatus={getFilterStatus}/>}
    title="Filter"
    trigger="click"
    placement="bottom"
    open={filterOpen}
    onOpenChange={handleOpenChange}>        
    <AntButton type={"primary"} text={'Filter'} size={'large'} color={"#b9bec3"}  dot={filterStatus}/>
    </Popover>
    )}
export default AntFilter;
